import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '../MaterialIcon';
import styles from './InlineError.module.scss';

const InlineError = ({ message }: { message: string }): ReactElement => {
    const { t: txt } = useTranslation();
    return (
        <div className={styles.section}>
            <MaterialIcon extraClass={styles.icon} name="error_outline" />
            {txt(message)}
        </div>
    );
};

export default InlineError;
